module.exports = __webpack_public_path__ + "static/media/-ve7.17b2b1c6.png";